<template>
  <div class="app-base-canvas bg-background">
    <div id="header">
      <admin-header @toggle-sidebar-visibility="toggleSidebarVisibility" />
    </div>
    <!-- Overlay to detect clicks outside sidebar on mobile -->
    <div
      v-if="!responsiveBreakpointMd && sidebarVisible"
      class="sidebar-overlay"
      @click="handleOverlayClick"
      @touchstart="handleOverlayClick"
    ></div>
    <div id="content">
      <div id="sidebar">
        <admin-sidebar
          :hide="!sidebarVisible"
          @close="closeSidebar"
          @menuItemClick="onMenuItemClick"
        />
      </div>
      <div id="content-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';
import AdminHeader from '../components/menu/AdminHeader.vue';
import AdminSidebar from '../components/menu/AdminSidebar.vue';
import {HitBreakpointsMixin} from '@hit/components';

export default defineComponent({
  name: 'AdminLayout',
  mixins: [HitBreakpointsMixin],
  components: {AdminHeader, AdminSidebar},
  data() {
    return {
      sidebarVisible: true,
    };
  },
  watch: {
    responsiveBreakpointMd: {
      handler(newValue) {
        this.sidebarVisible = !!newValue;
      },
      immediate: true,
    },
  },
  methods: {
    toggleSidebarVisibility() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    closeSidebar() {
      this.sidebarVisible = false;
    },
    onMenuItemClick() {
      // On mobile, close the sidebar after navigation (same behavior as Hit-Online)
      if (!this.responsiveBreakpointMd) this.closeSidebar();
    },
    handleOverlayClick(event) {
      // Prevent clicks reaching content below the overlay
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.closeSidebar();
    },
  },
  beforeMount() {
    // Hide the sidebar menu when opened on a mobile device
    if (!this.responsiveBreakpointMd) {
      this.sidebarVisible = false;
    }
  },
});
</script>

<style lang="scss">
.app-base-canvas {
  height: 100vh;
  display: grid;
  grid-template-rows: max-content minmax(0, 1fr);
  grid-template-areas:
    'header'
    'content';
  overflow: hidden;

  #content {
    grid-area: content;
    display: grid;
    grid-template-rows: minmax(0, 1fr);
    grid-template-columns: max-content minmax(0, 1fr);
    grid-template-areas: 'sidebar content-body';
  }

  #content-body {
    grid-area: content-body;
    display: grid;
    grid-template-rows: minmax(0, 1fr);
    grid-template-columns: 1fr;
    padding-bottom: 0.75rem;
    overflow: auto;
    margin-top: 1rem;
    @apply px-4;
  }
  .sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.1);
    z-index: 20;
    cursor: pointer;
  }
}
</style>
